export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";
export const PROJECT_KEY = import.meta.env.VITE_PROJECT_KEY || "TOURFLOW";
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL || "support@tourflow.ru";

export const STORAGE_KEYS = {
  REFRESH_TOKEN: "tourflow_refresh_token",
  THEME: "tourflow_theme",
  COOKIE_CONSENT: "tourflow_cookie_consent",
} as const;

export const MAX_RECORDING_SECONDS = 120;

export const QUICK_TAGS = [
  "Турция",
  "Египет",
  "Таиланд",
  "Мальдивы",
  "ОАЭ",
  "Пляжный отдых",
  "Горнолыжный",
  "Экскурсии",
] as const;
